export default "__VITE_ASSET__A9ynsZZO__"